import JSZip from "jszip";
import { saveAs } from "file-saver"; // Install with `npm install file-saver`

const downloadAllControlImages = async (control, nom) => {
  const zip = new JSZip();
  const imgfiles = [];

  // per category and subcategory
  control.cochamps.forEach((cochamp) => {
    const categoryName = cochamp.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_");
    
    cochamp.champs.forEach((champ) => {
      const subcategoryName = champ.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_");
      
      if (champ.type === "img" && champ.content?.length > 0) {
        for (let i = 0; i < champ.content.length; i++) {
          imgfiles.push({
            url: champ.content[i],
            category: categoryName,
            subcategory: subcategoryName,
            name: subcategoryName + "_" + i + ".jpg",
          });
        }
      } else if (champ.type === "imgtext" && champ.content?.length > 0) {
        imgfiles.push({
          url: champ.content[1],
          category: categoryName,
          subcategory: subcategoryName,
          name: subcategoryName + ".jpg",
        });
      }
    });
  });

  // Fetch each image and add it to the zip with folder structure
  for (const imgfile of imgfiles) {
    const { url, category, subcategory, name } = imgfile;
    const folderPath = `${category}/${subcategory}/${name}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${name}: ${response.statusText}`);
      }

      const blob = await response.blob();
      zip.file(folderPath, blob); // Add the fetched blob to the zip with folder structure
    } catch (error) {
      console.error(`Error adding ${name} to zip:`, error.message);
    }
  }

  // Generate the zip file and trigger download
  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(
      content,
      `${control.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_")}_images_controle.zip`
    ); // Prompt user to download zip file
  });
};

export default downloadAllControlImages;
